'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'flux-capacitor';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'f8ba';
var svgPathData = 'M384 64c17.7 0 32 14.3 32 32l0 320c0 17.7-14.3 32-32 32L64 448c-17.7 0-32-14.3-32-32L32 96c0-17.7 14.3-32 32-32l320 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm248 96c22.1 0 40 17.9 40 40s-17.9 40-40 40c-6.2 0-12.2-1.4-17.4-4L314 188.5c6.9-5.5 8-15.6 2.5-22.5s-15.6-8-22.5-2.5l-20.3 16.2c-1.1-3.7-1.7-7.6-1.7-11.7 0-22.1 17.9-40 40-40zm-43.8 97.1c12.1 9.3 27.3 14.9 43.8 14.9 39.8 0 72-32.2 72-72s-32.2-72-72-72-72 32.2-72 72c0 11.7 2.8 22.7 7.7 32.5l-23.7 19-23.7-19c5-9.8 7.7-20.8 7.7-32.5 0-39.8-32.2-72-72-72s-72 32.2-72 72 32.2 72 72 72c16.5 0 31.7-5.5 43.8-14.9l28.2 22.5 0 26.1c-32.1 7.3-56 35.9-56 70.2 0 39.8 32.2 72 72 72s72-32.2 72-72c0-34.3-23.9-62.9-56-70.2l0-26.1 28.2-22.5zM208 307.3l0 28.7c0 8.8 7.2 16 16 16s16-7.2 16-16l0-28.7c14.1 6.2 24 20.3 24 36.7 0 22.1-17.9 40-40 40s-40-17.9-40-40c0-16.4 9.9-30.5 24-36.7zM153.4 204c-5.3 2.5-11.2 4-17.4 4-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40c0 4.1-.6 8-1.7 11.7L154 163.5c-6.9-5.5-17-4.4-22.5 2.5s-4.4 17 2.5 22.5L153.4 204z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFluxCapacitor = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;